import type { AcceptConflictDialogData } from '@/apps/mwd-v2/state/types/ActionStore';

/**
 * Resolves which werklijnIds to render. Prefers the werklijnIds referenced by
 * dialogData; when there are none it falls back to the currently selected werklijnId.
 */
export const resolveWerklijnIds = (
  dialogData: AcceptConflictDialogData[] | null | undefined,
  selectedWerklijnId: string | undefined,
): string[] => {
  if (dialogData?.length) {
    return Array.from(new Set(dialogData.map((d) => d.werklijnId).filter((id): id is string => Boolean(id))));
  }

  return selectedWerklijnId ? [selectedWerklijnId] : [];
};
